import { useQuery } from '@tanstack/react-query';
import { revisionsAPI } from '../utils/api';

export type OfferRevision = Awaited<ReturnType<typeof revisionsAPI.list>>['data'][number];
export type RevisionDocument = Awaited<ReturnType<typeof revisionsAPI.documents>>['data'][number];

export function useOfferRevisions(id: string) {
  const query = useQuery({
    queryKey: ['offer-revisions', id],
    enabled: !!id,
    queryFn: async () => (await revisionsAPI.list(id)).data,
    staleTime: 30_000,
  });
  const ordered = [...(query.data || [])].sort((a, b) => b.numero_revisione - a.numero_revisione);
  return { query, current: ordered[0], previous: ordered.slice(1), total: ordered.length };
}

/** A format can have several stored exports; downloads use its newest file version. */
export function latestRevisionDocuments(documents: RevisionDocument[]) {
  const latest = new Map<string, RevisionDocument>();
  documents.forEach(document => {
    if (!document.url) return;
    const existing = latest.get(document.tipo);
    if (!existing || document.versione > existing.versione) latest.set(document.tipo, document);
  });
  return latest;
}
